<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-bookmark</v-icon>
        <h1 class="title ml-2">Matutina</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              v-model="libroSelected"
              :items="libros"
              item-text="label"
              item-value="id"
              label="Libro"
            ></v-select>
          </v-col>
          <v-col cols="12" md="9">
            <v-btn color="primary" class="mr-2" @click="showNew = true">
              <v-icon left>fas fa-plus</v-icon>
              Agregar
            </v-btn>
            <v-btn-toggle rounded>
              <v-btn @click="prev()">
                <v-icon left>fas fa-arrow-left</v-icon>
                Anterior
              </v-btn>
              <v-btn @click="next()">
                Siguiente
                <v-icon right>fas fa-arrow-right</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Título</th>
                <th>Libro</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in matutinas" :key="item.id">
                <td>{{item.fecha}}</td>
                <td v-html="item.title" />
                <td>{{item.libro.titulo}}</td>
                <td class="max-width-120">
                  <v-btn small fab text color="primary" @click="showItem(item)">
                    <v-icon>fas fa-list</v-icon>
                  </v-btn>
                  <v-btn small fab text color="secondary" @click="editItem(item)">
                    <v-icon>fas fa-edit</v-icon>
                  </v-btn>
                  <v-btn small fab text color="error" @click="deleteItem(item.id)">
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <!-- ------------------------------------------------------------------- -->
    <!-- New matutina -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showNew" max-width="600">
      <edit-matutina
        title="Agregar matutina"
        icon="fas fa-plus"
        v-model="newMatutina"
        @close="showNew = false"
        ref="newMatutina"
        @save="saveMatutina()"
      ></edit-matutina>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- Edit matutina -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showEdit" max-width="600">
      <edit-matutina
        title="Editar matutina"
        icon="fas fa-edit"
        v-model="editMatutina"
        @close="showEdit = false"
        @save="updateMatutina()"
      ></edit-matutina>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- Show matutina -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showDetail" max-width="600" scrollable>
      <show-matutina
        v-model="detailMatutina"
        @close="showDetail = false"
      ></show-matutina>
    </v-dialog>
  </v-container>
</template>

<script>
import EditMatutina from '../components/EditMatutina'
import ShowMatutina from '../components/ShowMatutina'
import { mapMutations } from 'vuex'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
export default {
  data () {
    return {
      matutinas: [],
      showNew: false,
      showEdit: false,
      showDetail: false,
      newMatutina: {
        contenido: '',
        fecha: '',
        libro: '',
        titulo: '',
        versiculo: '---'
      },
      editMatutina: null,
      detailMatutina: null,
      libroSelected: null,
      libros: [],
      pagina: 0
    }
  },
  computed: {
    url () {
      if (this.libroSelected) {
        return `?libro=${this.libroSelected}&_limit=20&_sort=fecha:DESC&_start=${this.pagina * 20}`
      } else {
        return `?_limit=20&_sort=fecha:DESC&_start=${this.pagina * 20}`
      }
    }
  },
  components: {
    EditMatutina,
    ShowMatutina
  },
  methods: {
    ...mapMutations(['setLibros']),
    editItem (matutina) {
      this.editMatutina = matutina
      this.showEdit = true
    },
    showItem (matutina) {
      this.detailMatutina = matutina
      this.showDetail = true
    },
    deleteItem (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        this.$http.matutinas
          .delete(`/${id}`)
          .then(() => {
            this.getMatutinas()
          })
      }
    },
    getMatutinas () {
      this.$http.matutinas
        .get(this.url)
        .then(res => res.data)
        .then(res => {
          this.matutinas = res.map(i => ({
            ...i,
            fecha: dayjs(i.fecha).utc().format('DD-MM-YYYY'),
            title: i.titulo.substr(0, 60)
          }))
        })
    },
    getLibros () {
      this.$http.libros
        .get('?_sort=anho:DESC')
        .then(res => res.data)
        .then(res => {
          this.libros = res.map(i => {
            return {
              id: i.id,
              label: `${i.titulo} - ${i.tipo} - ${i.anho}`
            }
          })
          this.setLibros(this.libros)
        })
    },
    saveMatutina () {
      this.$http.matutinas
        .post('', this.newMatutina)
        .then(() => {
          this.$refs['newMatutina'].reset()
          this.getMatutinas()
          this.showNew = false
        })
    },
    updateMatutina () {
      this.$http.matutinas
        .put(`/${this.editMatutina.id}`, this.editMatutina)
        .then(() => {
          this.getMatutinas()
          this.showEdit = false
        })
    },
    next () {
      if (this.matutinas.length) {
        this.pagina = this.pagina + 1
      }
    },
    prev () {
      if (this.pagina > 0) {
        this.pagina = this.pagina - 1
      }
    }
  },
  mounted () {
    this.getLibros()
    this.getMatutinas()
  },
  watch: {
    libroSelected () {
      this.getMatutinas()
    },
    pagina () {
      this.getMatutinas()
    }
  }
}
</script>
